import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import { useTheme } from '@mui/system';

import Icon from 'src/common/components/icons/Icon';
import { LanguageKeys } from 'src/common/constants/languages';
import { ICompetition } from 'src/interfaces/Competition';

interface Props {
  competition: ICompetition;
  distanceLabel: string;
  currentLang: LanguageKeys;
}

export default function RegistrationAvatar({ competition, distanceLabel, currentLang }: Props) {
  const { palette } = useTheme();

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        <Avatar
          sx={{
            background: `linear-gradient(135deg, ${palette.primary.dark} 0%, ${palette.primary.light} 100%)`,
            p: 0.5,
            width: 24,
            height: 24,
            border: theme => `1px solid ${theme.palette.background.paper}`,
            fontSize: 9,
            textAlign: 'center',
          }}
        >
          {distanceLabel}
        </Avatar>
      }
    >
      <Avatar
        sx={{
          background: `linear-gradient(135deg, ${palette.success.dark} 0%, ${palette.success.light} 100%)`,
        }}
        aria-label={competition.i18n[currentLang]}
      >
        <Icon icon={competition.icon} />
      </Avatar>
    </Badge>
  );
}
